"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiServer = null;
function setApiServer(newApiServer) {
    exports.apiServer = newApiServer;
}
exports.setApiServer = setApiServer;
exports.clientSecret = '';
function setClientSecret(newClientSecret) {
    exports.clientSecret = newClientSecret;
}
exports.setClientSecret = setClientSecret;
